<div class="counter">
    <ng-container *ngFor="let group of groups; let gi = index">
      <div class="group">
        <ng-container *ngFor="let d of group; let di = index">
          <div class="digit">
            <div #reel class="reel">
              <!-- (0..9) * loops -->
              <ng-container *ngFor="let _ of [].constructor(loops)">
                <span>0</span><span>1</span><span>2</span><span>3</span><span>4</span>
                <span>5</span><span>6</span><span>7</span><span>8</span><span>9</span>
              </ng-container>
  
              <!-- Then 0..finalDigit -->
              <ng-container [ngSwitch]="d">
                <span>0</span>
                <ng-container *ngSwitchCase="1"><span>1</span></ng-container>
                <ng-container *ngSwitchCase="2"><span>1</span><span>2</span></ng-container>
                <ng-container *ngSwitchCase="3"><span>1</span><span>2</span><span>3</span></ng-container>
                <ng-container *ngSwitchCase="4"><span>1</span><span>2</span><span>3</span><span>4</span></ng-container>
                <ng-container *ngSwitchCase="5"><span>1</span><span>2</span><span>3</span><span>4</span><span>5</span></ng-container>
                <ng-container *ngSwitchCase="6"><span>1</span><span>2</span><span>3</span><span>4</span><span>5</span><span>6</span></ng-container>
                <ng-container *ngSwitchCase="7"><span>1</span><span>2</span><span>3</span><span>4</span><span>5</span><span>6</span><span>7</span></ng-container>
                <ng-container *ngSwitchCase="8"><span>1</span><span>2</span><span>3</span><span>4</span><span>5</span><span>6</span><span>7</span><span>8</span></ng-container>
                <ng-container *ngSwitchCase="9"><span>1</span><span>2</span><span>3</span><span>4</span><span>5</span><span>6</span><span>7</span><span>8</span><span>9</span></ng-container>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </div>
  
      <!-- thousands separator -->
      <!-- div class="sep" *ngIf="gi < groups.length - 1">{{ separatorChar }}</div-->
    </ng-container>
  </div>
  